// eyeq — гайд фотографа как Telegram Mini App (ADR-0085).
//
// Живые цифры плана: eyeq-воркер отдаёт остатки по ячейкам локали той же
// формулой, что и очередь QA (intakeRemaining); бот app.weern.com спрашивает
// их при каждом открытии гайда. Статика гайда (правила, примеры, названия
// категорий, подсказки «куда идти») живёт в воркере бота.
import { z } from 'zod';

// ── GET /api/eyeq/guide/remaining?locale= (ingest) ──────────────────────────
export const EyeqGuideCellSchema = z.object({
  category: z.string(),
  sub_category: z.string(),
  url_required: z.boolean(),
  target: z.number().int(),     // эффективная квота ячейки (с переносами)
  filled: z.number().int(),     // принятые intake + собранное вне intake
  remaining: z.number().int(),  // max(0, target − filled)
});
export type EyeqGuideCell = z.infer<typeof EyeqGuideCellSchema>;

export const EyeqGuideRemainingResSchema = z.object({
  locale: z.string(),
  cells: z.array(EyeqGuideCellSchema),
  total_remaining: z.number().int(),
  updated_at: z.string(),
});
export type EyeqGuideRemainingRes = z.infer<typeof EyeqGuideRemainingResSchema>;

// ── POST /api/tg/app/guide (бот, по initData) ───────────────────────────────
// state: unknown — человек не из лейна app.weern.com; onboarding — не выбрал
// язык или не сдал пробный кадр; ready — гайд его страны.
export const TgAppGuideResSchema = z.object({
  state: z.enum(['unknown', 'onboarding', 'ready']),
  lang: z.string().default(''),       // язык лейна ('' = не выбран)
  locale: z.string().default(''),     // локаль приглашения
  step: z.enum(['', 'lang', 'test']).default(''), // какой шаг онбординга ещё не пройден
  cells: z.array(EyeqGuideCellSchema).default([]),
  total_remaining: z.number().int().default(0),
  updated_at: z.string().default(''),
});
export type TgAppGuideRes = z.infer<typeof TgAppGuideResSchema>;
